const n = {
  primary: "--brand-primary",
  secondary: "--brand-secondary",
  info: "--brand-info",
  success: "--brand-success",
  warning: "--brand-warning",
  danger: "--brand-danger"
}, a = (r) => `var(${n[`${r}`]})`;
export {
  a as getCurrentBackgroundColor
};
//# sourceMappingURL=currentColors.js.map
